import React from "react";
import { Link } from "react-router-dom";
import ArrowForward from "@mui/icons-material/ArrowForward";
import NorthEast from "@mui/icons-material/NorthEast";
import SpaOutlined from "@mui/icons-material/SpaOutlined";
import LocalFireDepartmentOutlined from "@mui/icons-material/LocalFireDepartmentOutlined";
import RestaurantOutlined from "@mui/icons-material/RestaurantOutlined";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
const biryani = `${process.env.PUBLIC_URL}/chickenBiryani-1064.webp`;
const friedRice = `${process.env.PUBLIC_URL}/friedRice-1064.webp`;

const promises = [
  [SpaOutlined, "Fresh, quality ingredients"],
  [LocalFireDepartmentOutlined, "Made fresh. Served with love."],
  [RestaurantOutlined, "Authentic flavors, every time"],
  [FavoriteBorder, "Your cravings, our craft"],
];

function HomeFirstSection() {
  return (
    <section className="home-hero" aria-labelledby="hero-title">
      <div className="hero-scene">
        <div className="hero-garnishes" aria-hidden="true">
          <i className="leaf leaf-one" /><i className="leaf leaf-two" />
          <i className="leaf leaf-three" /><i className="leaf leaf-four" />
          <i className="tomato tomato-one" /><i className="tomato tomato-two" />
          <i className="lemon lemon-one" /><i className="lemon lemon-two" />
          <i className="spice spice-one">✦</i><i className="spice spice-two">✦</i>
        </div>
        <figure className="hero-dish hero-dish-left">
          <div className="hero-plate"><img src={biryani} srcSet={`${process.env.PUBLIC_URL}/chickenBiryani-480.webp 480w, ${biryani} 1064w`} sizes="(max-width: 600px) 52vw, 34vw" width="1064" height="804" decoding="async" alt="Chicken biryani serving suggestion" fetchpriority="high" /></div>
          {/* <figcaption><Link to="/menu">Chicken biryani <NorthEast /></Link></figcaption> */}
        </figure>
        <div className="hero-copy">
          <p className="hero-eyebrow">Rooted in tradition. Made with love.</p>
          <h1 id="hero-title">A little spice.<br />A lot of <em>heart.</em></h1>
          <p className="hero-description">Fresh from our kitchen. Full of flavor.<br />A little taste of home in every bite.</p>
          <Link className="hero-menu-button" to="/menu">Explore Our Menu <ArrowForward /></Link>
          <Link className="hero-book-link" to="/book-your-table">Book a Table <NorthEast /></Link>
          <p className="hero-fresh"><span /> Freshly made. Never ordinary.</p>
        </div>
        <figure className="hero-dish hero-dish-right">
          <div className="hero-plate"><img src={friedRice} width="500" height="512" decoding="async" alt="Vegetable fried rice serving suggestion" /></div>
          {/* <figcaption><Link to="/menu">Vegetable fried rice <NorthEast /></Link></figcaption> */}
        </figure>
        <div className="hero-footnote"><span>Basyal Bhojan Ghar <b>•</b> A taste of home</span><a href="#home-menu">Scroll to discover ↓</a></div>
      </div>
      <div className="hero-promises">
        {promises.map(([Icon, label]) => <div key={label}><Icon aria-hidden="true" /><span>{label}</span></div>)}
      </div>
    </section>
  );
}

export default React.memo(HomeFirstSection);
